module.exports = __webpack_public_path__ + "static/media/listIconSelected.9f21018c.svg";